if (!customElements.get('workshop-project')) {
  customElements.define('workshop-project', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }, { capture: true }));
      const slides = [...this.querySelectorAll('[data-wp-slide]')];
      const thumbs = [...this.querySelectorAll('[data-wp-thumb]')];
      let index = Math.max(0, slides.findIndex(slide => !slide.hidden));
      const show = next => {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        this.querySelector('[data-wp-count]').textContent = `${index + 1} / ${slides.length}`;
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      this.querySelector('[data-wp-prev]').addEventListener('click', () => show(index - 1));
      this.querySelector('[data-wp-next]').addEventListener('click', () => show(index + 1));
      this.querySelector('.wp-gallery').addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      const form = this.querySelector('form');
      const radios = [...form.querySelectorAll('[data-wp-variant]')];
      const submits = [...form.querySelectorAll('[data-wp-submit]')];
      const update = input => {
        this.querySelectorAll('[data-wp-price]').forEach(el => { el.textContent = input.dataset.wpMoney; });
        this.querySelector('[data-wp-license]').textContent = input.closest('label').querySelector('strong').textContent;
        submits.forEach(button => { button.disabled = input.dataset.wpAvailable !== 'true'; });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
      };
      radios.forEach(radio => radio.addEventListener('change', () => update(radio)));
      this.querySelectorAll('[data-wp-select-license]').forEach(button => button.addEventListener('click', () => {
        const input = radios.find(radio => radio.value === button.dataset.wpSelectLicense);
        if (!input) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }));
      const current = radios.find(radio => radio.checked);
      if (current) submits.forEach(button => { button.disabled = current.dataset.wpAvailable !== 'true'; });
      let busy = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopPropagation();
        const selected = radios.find(radio => radio.checked);
        if (busy || !selected || selected.dataset.wpAvailable !== 'true') return;
        busy = true;
        submits.forEach(button => { button.disabled = true; });
        const status = this.querySelector('[data-wp-status]');
        status.textContent = this.dataset.adding;
        const checkout = event.submitter?.hasAttribute('data-wp-checkout');
        try {
          const response = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error('Unable to add variant');
          window.location.assign(checkout ? this.dataset.checkoutUrl : this.dataset.cartUrl);
        } catch (error) {
          status.textContent = this.dataset.error;
          busy = false;
          submits.forEach(button => { button.disabled = selected.dataset.wpAvailable !== 'true'; });
        }
      });
    }
  });
}
